import _property from 'lodash/property';
import { tget } from 'tbase/utils/general';

var availableQuantity = _property('quantity.available');

var id = _property('id');

var inProgressQuantity = _property('quantity.inProgressQty');

var maximumQuantity = _property('quantity.maximumQty');

var minimumQuantity = _property('quantity.minimumQty');

var name = _property('partName');

var onHandQuantity = function onHandQuantity(partInfo) {
  return tget(partInfo, 'quantity.onHandQty', 0);
};

var onOrderQuantity = _property('quantity.onOrderQty');

var stockParamType = _property('stockParamType');

var unitPackQty = _property('unitPackQty');

var partId = _property('partId');

var partNumber = _property('partNumber');

var dmsPartNumber = _property('dmsPartNumber');

var partName = _property('partName');

var primaryBinId = _property('primaryBinId');

var binIds = _property('binIds');

var sourceCodeId = _property('sourceCodeId');

var sourceType = _property('partSourceType');

var totalQuantity = _property('quantity.totalQty');

var listPrice = _property('listPrice');

var tradePrice = _property('tradePrice');

var comp = _property('comp');

var cost = _property('cost');

var partDescription = _property('description');

var alternateItemId = _property('alternateItemId');

var partSaleDetails = _property('partSaleDetails');

var partAcquisitions = _property('partAcquisitions');

var adhocPartInfo = _property('adhocPartInfo');

var userId = _property('userId');

var createdTime = _property('createdTime');

var lastModifiedByUserId = _property('lastModifiedByUserId');

var modifiedTime = _property('modifiedTime');

var coreReturnEligible = _property('coreReturnEligible');

var coreValue = function coreValue(partInfo) {
  return tget(partInfo, 'coreValue', 0);
};

var corePartNumber = _property('corePartNumber');

var partSourceType = _property('partSourceType');

var temporaryPart = _property('temporaryPart');

var overrideNewSupersessions = _property('partMasterOverride.additionalPartDetails.newSupersessions');

var overrideOldSupersessions = _property('partMasterOverride.additionalPartDetails.oldSupersessions');

var newSupersessions = _property('additionalPartDetails.newSupersessions');

var oldSupersessions = _property('additionalPartDetails.oldSupersessions');

var inactive = _property('inactive');

var manufacturerId = _property('manufacturerId');

var vendorId = _property('vendorId');

var partGroup = _property('group');

var associatedPartNumber = _property('associatedPartNumber'); // additional details


var makeUsageBrands = _property('makeUsage');

var autoUpdateFlag = _property('autoUpdateFlag');

var unitOfMeasure = _property('unitOfMeasure');

var hazardousIndicator = _property('hazardousIndicator');

var partsClassification = _property('partsClassification');

var firstYear = _property('firstYear');

var lastYear = _property('lastYear');

var cancelYear = _property('cancelYear');

var remanufactureIndicator = _property('remanufactureIndicator');

var truckPartIndicator = _property('truckPartIndicator');

var lifetimeWarranty = _property('lifetimeWarranty');

var inventoryLifeTimeWarranty = _property('lifeTimeWarranty');

var serviceLaneIndicator = _property('serviceLaneIndicator');

var priceControlIndicator = _property('priceControlIndicator');

var materialReturnCode = _property('materialReturnCode');

var repackCode = _property('repackCode');

var returnEligibility = _property('returnEligibility');

var partShelfLife = _property('partShelfLife');

var abcXyz = _property('abcXyz');

var compPriceOverride = _property('partMasterOverride.comp');

var makeUsageBrandOverride = _property('partMasterOverride.makeUsageBrands');

var stockingStatus = _property('stockingStatus');

var unitOfMeasureOverride = _property('partMasterOverride.unitOfMeasure');

var mfrControlled = _property('mfrControlled');

var mfrControlledUnit = _property('rimCode');

var abcdCode = _property('abcdCode');

var bestReOrderPoint = _property('bestReOrderPoint');

var bestStockingLevel = _property('bestStockingLevel');

var partComments = _property('partComments.0.comment');

var partMasterOverride = _property('partMasterOverride');

var inventoryCustomizedPriceOverrides = _property('customizedPriceOverrides');

var oemCode = _property('oemCode');

var brandCode = _property('brandCode');

var asrBsl = _property('asrBsl');

var asrBrp = _property('asrBrp');

var minimumBuyQty = _property('minimumBuyQty');

var maximumBuyQty = _property('maximumBuyQty');

var partWeight = _property('pckPartWeight.content');

var partWeightUnit = _property('pckPartWeight.unitOfMeasure');

var partHeight = _property('partHeight.content');

var partHeightUnit = _property('partHeight.unitOfMeasure');

var partLength = _property('partLength.content');

var partLengthUnit = _property('partLength.unitOfMeasure');

var partWidth = _property('partWidth.content');

var partWidthUnit = _property('partWidth.unitOfMeasure');

var classCode = _property('classCode');

var mfrGuaranteeQuantity = _property('mfrGuaranteeQuantity');

var partSupplyStatusCode = _property('partSupplyStatusCode');

var lastSaleDate = _property('lastSaleDate');

var lastReceiptDate = _property('lastReceiptDate');

var oemBrandAdditional = _property('oemBrand');

var wholesaleDiscountEligible = _property('wholesaleDiscountEligible');

var lastMasterUpdateTime = _property('lastMasterUpdateTime');

var dealerId = _property('dealerId');

var partClassCode = _property('partClassCode');

var manualOrder = _property('manualOrder');

var partSourceCode = _property('partSourceCode');

var shipCode = _property('shipCode');

var partTypeCode = _property('partTypeCode');

var inventoryPartDetail = _property('inventoryPartDetail');

var wholesaleTypeCode = _property('wholesaleTypeCode');

var obsoleteStatus = _property('obsoleteStatus');

var pricingDiscount = _property('pricingDiscount');

var cppp = _property('cppp');

var productHierarchy = _property('productHierarchy');

var oemCountry = _property('oemCountry');

var kitConditionalOrder = _property('kitConditionalOrder');

var dealerPriceVor = _property('dealerPriceVor');

var discountCode = _property('discountCode');

var avgDemandQuantity = _property('avgDemandQuantity');

var isLinkedToMaster = _property('linkStatusToMaster');

var isAvailableInMaster = _property('availableInMaster'); // linked parts details


var defaultAlternateParts = _property('additionalPartDetails.alternateParts');

var defaultAssociatedParts = _property('additionalPartDetails.associatedParts');

var alternatePartsOverride = _property('partMasterOverride.additionalPartDetails.alternateParts');

var associatedPartsOverride = _property('partMasterOverride.additionalPartDetails.associatedParts');

var READER = {
  availableQuantity: availableQuantity,
  id: id,
  inProgressQuantity: inProgressQuantity,
  maximumQuantity: maximumQuantity,
  minimumQuantity: minimumQuantity,
  name: name,
  onHandQuantity: onHandQuantity,
  onOrderQuantity: onOrderQuantity,
  associatedPartNumber: associatedPartNumber,
  stockParamType: stockParamType,
  partId: partId,
  partNumber: partNumber,
  dmsPartNumber: dmsPartNumber,
  primaryBinId: primaryBinId,
  sourceCodeId: sourceCodeId,
  sourceType: sourceType,
  totalQuantity: totalQuantity,
  listPrice: listPrice,
  cost: cost,
  partDescription: partDescription,
  alternateItemId: alternateItemId,
  partSaleDetails: partSaleDetails,
  partAcquisitions: partAcquisitions,
  adhocPartInfo: adhocPartInfo,
  tradePrice: tradePrice,
  comp: comp,
  coreReturnEligible: coreReturnEligible,
  coreValue: coreValue,
  partSourceType: partSourceType,
  partName: partName,
  userId: userId,
  createdTime: createdTime,
  lastModifiedByUserId: lastModifiedByUserId,
  modifiedTime: modifiedTime,
  temporaryPart: temporaryPart,
  overrideNewSupersessions: overrideNewSupersessions,
  overrideOldSupersessions: overrideOldSupersessions,
  newSupersessions: newSupersessions,
  oldSupersessions: oldSupersessions,
  inactive: inactive,
  manufacturerId: manufacturerId,
  vendorId: vendorId,
  partGroup: partGroup,
  makeUsageBrands: makeUsageBrands,
  autoUpdateFlag: autoUpdateFlag,
  unitOfMeasure: unitOfMeasure,
  hazardousIndicator: hazardousIndicator,
  partsClassification: partsClassification,
  firstYear: firstYear,
  lastYear: lastYear,
  cancelYear: cancelYear,
  remanufactureIndicator: remanufactureIndicator,
  truckPartIndicator: truckPartIndicator,
  lifetimeWarranty: lifetimeWarranty,
  inventoryLifeTimeWarranty: inventoryLifeTimeWarranty,
  inventoryPartDetail: inventoryPartDetail,
  serviceLaneIndicator: serviceLaneIndicator,
  priceControlIndicator: priceControlIndicator,
  materialReturnCode: materialReturnCode,
  repackCode: repackCode,
  returnEligibility: returnEligibility,
  partShelfLife: partShelfLife,
  abcXyz: abcXyz,
  defaultAlternateParts: defaultAlternateParts,
  defaultAssociatedParts: defaultAssociatedParts,
  unitPackQty: unitPackQty,
  corePartNumber: corePartNumber,
  compPriceOverride: compPriceOverride,
  makeUsageBrandOverride: makeUsageBrandOverride,
  stockingStatus: stockingStatus,
  unitOfMeasureOverride: unitOfMeasureOverride,
  mfrControlled: mfrControlled,
  mfrControlledUnit: mfrControlledUnit,
  abcdCode: abcdCode,
  bestReOrderPoint: bestReOrderPoint,
  bestStockingLevel: bestStockingLevel,
  partComments: partComments,
  alternatePartsOverride: alternatePartsOverride,
  associatedPartsOverride: associatedPartsOverride,
  partMasterOverride: partMasterOverride,
  inventoryCustomizedPriceOverrides: inventoryCustomizedPriceOverrides,
  brandCode: brandCode,
  oemCode: oemCode,
  asrBsl: asrBsl,
  asrBrp: asrBrp,
  minimumBuyQty: minimumBuyQty,
  maximumBuyQty: maximumBuyQty,
  partWeight: partWeight,
  partWeightUnit: partWeightUnit,
  partHeight: partHeight,
  partHeightUnit: partHeightUnit,
  partLength: partLength,
  partLengthUnit: partLengthUnit,
  partWidth: partWidth,
  partWidthUnit: partWidthUnit,
  classCode: classCode,
  mfrGuaranteeQuantity: mfrGuaranteeQuantity,
  partSupplyStatusCode: partSupplyStatusCode,
  lastSaleDate: lastSaleDate,
  binIds: binIds,
  lastReceiptDate: lastReceiptDate,
  oemBrandAdditional: oemBrandAdditional,
  wholesaleDiscountEligible: wholesaleDiscountEligible,
  lastMasterUpdateTime: lastMasterUpdateTime,
  dealerId: dealerId,
  partClassCode: partClassCode,
  manualOrder: manualOrder,
  partSourceCode: partSourceCode,
  shipCode: shipCode,
  partTypeCode: partTypeCode,
  wholesaleTypeCode: wholesaleTypeCode,
  obsoleteStatus: obsoleteStatus,
  pricingDiscount: pricingDiscount,
  cppp: cppp,
  productHierarchy: productHierarchy,
  oemCountry: oemCountry,
  kitConditionalOrder: kitConditionalOrder,
  dealerPriceVor: dealerPriceVor,
  discountCode: discountCode,
  avgDemandQuantity: avgDemandQuantity,
  isLinkedToMaster: isLinkedToMaster,
  isAvailableInMaster: isAvailableInMaster
};
export default READER;